export interface Branding {
  logo_url?: string;
  primary_color?: string;
  accent_color?: string;
  bg_color?: string;
}

export function applyBranding(branding: Branding | null | undefined): void {
  const root = document.documentElement;

  if (!branding) {
    return;
  }

  if (branding.primary_color) {
    root.style.setProperty("--brand-primary", branding.primary_color);
  }

  if (branding.accent_color) {
    root.style.setProperty("--brand-accent", branding.accent_color);
  }

  if (branding.bg_color) {
    root.style.setProperty("--brand-bg", branding.bg_color);
  }
}

export function resetBranding(): void {
  const root = document.documentElement;
  root.style.removeProperty("--brand-primary");
  root.style.removeProperty("--brand-accent");
  root.style.removeProperty("--brand-bg");
}
